import React, { useCallback } from "react";
import {
  Wrapper,
  PillsTab,
  TabProps as TabRenderProps,
  ContrastPillsTab,
} from "./SwitchTabsStyled";
import ClassicTab from "./ClassicTab";
interface TabProps<Id, L> {
  id: Id;
  label: L;
}
export enum SwitchTabsType {
  classic,
  pills,
  contrastPills,
}
interface SwitchTabsProps<Id, L> {
  style?: React.CSSProperties;
  values?: TabProps<Id, L>[];
  value?: TabProps<Id, L>;
  handleChange?: (value: TabProps<Id, L>) => void;
  type?: SwitchTabsType;
  tabProps?: {
    style?: React.CSSProperties;
  };
  disabled?: boolean;
  tabRenderer?: (props: TabRenderProps) => JSX.Element;
  qaPrefix?: string
}

const TabFactory = (type?: SwitchTabsType) =>
  type === SwitchTabsType.contrastPills
    ? ContrastPillsTab
    : type === SwitchTabsType.pills
    ? PillsTab
    : ClassicTab;

function SwitchTabs<Id, L>({
  style,
  values,
  handleChange,
  value,
  type,
  tabProps = {},
  disabled,
  tabRenderer,
  qaPrefix
}: SwitchTabsProps<Id, L>) {
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      const id = (e.target as HTMLElement).dataset?.id;
      if (!id) return;
      const newValue = values?.find((el) => String(el.id) === id);
      if (newValue) {
        handleChange?.(newValue);
      }
    },
    [handleChange, values]
  );
  const Tab = tabRenderer || TabFactory(type);
  return (
    <Wrapper style={style}>
      {values?.map((el) => (
        <Tab
          key={"Tab" + el.id}
          disabled={disabled}
          activated={el.id === value?.id}
          data-id={String(el.id)}
          data-qa-id={qaPrefix && qaPrefix+String(el.id)}
          onClick={handleClick}
          {...tabProps}
        >
          {el.label as React.ReactNode}
        </Tab>
      ))}
    </Wrapper>
  );
}

export default SwitchTabs;
